import { Tooltip } from '@mairistem/composants';
import { Icon } from '@mairistem/finances-utils';
import React from 'react';
import type RegleCalcul from '../../../../interfaces/simulation/regleCalcul';
import CalculPropositionModalPopupContent from './CalculPropositionModalPopupContent';

interface CalculPropositionModalPopupProps {
	anneeExercice: number;
	regleCalcul: RegleCalcul;
}

const CalculPropositionModalPopup = ({
	anneeExercice,
	regleCalcul,
}: CalculPropositionModalPopupProps) => (
	<Tooltip
		data-testid="regleCalculPopup"
		message={
			<CalculPropositionModalPopupContent
				anneeExercice={anneeExercice}
				disabled
				lignesRegleCalcul={regleCalcul?.lignes}
				typeCalcul={regleCalcul?.typeCalcul}
			/>
		}
		trigger={
			<Icon
				cursor="pointer"
				data-testid="regleCalculIconPopup"
				iconSet="Lucide"
				name="Info"
			/>
		}
		offset={[8, 0]}
		on="click"
		position="bottom right"
		type="information"
	/>
);

export default CalculPropositionModalPopup;
